import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgCarryOnBaggage = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      aria-hidden="true"
      {...props}
    >
      <defs>
        <radialGradient
          id="carryOnBaggage_svg__b"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(11 28.122)scale(1.25)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.33} stopColor="#1F1F1F" />
          <stop offset={0.462} stopColor="#4D4D4D" />
          <stop offset={0.759} stopColor="#4D4D4D" />
          <stop offset={0.829} stopColor="#3B3B3B" />
          <stop offset={1} stopColor="#141414" />
        </radialGradient>
        <radialGradient
          id="carryOnBaggage_svg__c"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="translate(21 28.122)scale(1.25)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.33} stopColor="#1F1F1F" />
          <stop offset={0.462} stopColor="#4D4D4D" />
          <stop offset={0.759} stopColor="#4D4D4D" />
          <stop offset={0.829} stopColor="#3B3B3B" />
          <stop offset={1} stopColor="#141414" />
        </radialGradient>
        <radialGradient
          id="carryOnBaggage_svg__f"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(.2298 8.8703 -13.4344 .4478 16.004 19.037)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.63} stopColor="#2472BF" />
          <stop offset={1} stopColor="#11508F" />
        </radialGradient>
        <linearGradient
          id="carryOnBaggage_svg__d"
          x1={21}
          x2={21}
          y1={27.504}
          y2={28.034}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#141414" />
          <stop offset={1} stopColor="#141414" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="carryOnBaggage_svg__e"
          x1={10.999}
          x2={10.999}
          y1={27.504}
          y2={28.034}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#141414" />
          <stop offset={1} stopColor="#141414" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="carryOnBaggage_svg__g"
          x1={15.066}
          x2={20.973}
          y1={20.002}
          y2={20.002}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.102} stopColor="#fff" />
          <stop offset={0.115} stopColor="#E3E3E3" />
          <stop offset={0.204} stopColor="#fff" />
          <stop offset={0.214} stopColor="#E3E3E3" />
          <stop offset={0.233} stopColor="#E3E3E3" />
          <stop offset={0.446} stopColor="#fff" stopOpacity={0.973} />
          <stop offset={0.455} stopColor="#E3E3E3" />
          <stop offset={0.549} stopColor="#fff" />
          <stop offset={0.56} stopColor="#E3E3E3" />
          <stop offset={1} stopColor="#E3E3E3" />
        </linearGradient>
        <filter
          id="carryOnBaggage_svg__a"
          width={19.645}
          height={4.617}
          x={6.174}
          y={27.063}
          filterUnits="userSpaceOnUse"
        >
          <feGaussianBlur stdDeviation={1} />
        </filter>
      </defs>
      <g filter="url(#carryOnBaggage_svg__a)" opacity={0.5}>
        <ellipse cx={15.996} cy={29.372} fill="#000" rx={7.822} ry={0.309} />
      </g>
      <path
        fill="url(#carryOnBaggage_svg__b)"
        d="M11 29.372a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
      />
      <path
        fill="url(#carryOnBaggage_svg__c)"
        d="M21 29.372a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
      />
      <path
        fill="url(#carryOnBaggage_svg__d)"
        d="M21 26.872c.69 0 1.25.56 1.25 1.25h-2.5c0-.69.559-1.25 1.25-1.25"
      />
      <path
        fill="url(#carryOnBaggage_svg__e)"
        d="M11 26.872c.69 0 1.25.56 1.25 1.25h-2.5c0-.69.559-1.25 1.25-1.25"
      />
      <path
        fill="#868686"
        d="M17.876 3.569h-3.75v10.342h-1.25V3.57c0-.73.56-1.322 1.25-1.322h3.75c.69 0 1.25.592 1.25 1.322v10.342h-1.25V3.57Z"
      />
      <path
        fill="url(#carryOnBaggage_svg__f)"
        d="M21.723 10.163H10.271c-1.103 0-1.998.95-1.998 2.123V26c0 1.173.895 2.123 1.998 2.123h11.452c1.104 0 1.998-.95 1.998-2.123V12.286c0-1.172-.895-2.123-1.998-2.123"
      />
      <path
        fill="#6CA2D7"
        d="M13.97 13.226c-.173 0-.313.151-.313.338V25.6c0 .187.14.338.312.338.173 0 .313-.151.313-.338V13.564c0-.187-.14-.338-.313-.338Zm2.032 0c-.172 0-.312.151-.312.338V25.6c0 .187.14.338.312.338.173 0 .313-.151.313-.338V13.564c0-.187-.14-.338-.313-.338m2.03 0c-.172 0-.312.151-.312.338V25.6c0 .187.14.338.312.338.173 0 .313-.151.313-.338V13.564c0-.187-.14-.338-.313-.338"
      />
      <path
        fill="url(#carryOnBaggage_svg__g)"
        d="M16.171 22.176s-.17-.512-.348-.673l-.757-2.012.768-.289s.179-.163.33-.215c.152-.05.314-.027.314-.027l1.253-.472.297-.202.303-.024.773-.392.108.025c.06.188.3.881.3.881l.731 1.942-.502.275-.262.15-.375.09-.755.323s-.155-.044-.322.026-.313.213-.313.213l-1.246.47a2 2 0 0 0-.297-.089"
      />
      <path
        fill="#1C1C1C"
        d="M19.122 3.497h-6.25c0-.691.559-1.25 1.25-1.25h3.75c.69 0 1.25.559 1.25 1.25"
      />
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgCarryOnBaggage);
export default Memo;
